export type SnoozePreset = {
  label: string;
  hours: number;
};

export const SNOOZE_PRESETS: ReadonlyArray<SnoozePreset> = [
  { label: 'Later today (4h)', hours: 4 },
  { label: 'Tomorrow (1d)', hours: 24 },
  { label: 'This week (2d)', hours: 48 },
  { label: 'Next week (1w)', hours: 24 * 7 },
];

export const computeSnoozedUntil = (hours: number, now = new Date()): string =>
  new Date(now.getTime() + hours * 60 * 60 * 1000).toISOString();
